export enum LastLoginMethod {
  OTP = 'otp',
  EMAIL_PASSWORD = 'email_password'
} 